import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';
import { Environment } from 'src/environments/environment.model';

@Component({
  selector: 'app-co2-impact',
  templateUrl: './co2-impact.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PowerbiReportComponent],
})
export class CO2ImpactComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  public readonly workspaceId: string;
  public readonly reportId: string;

  constructor() {
    this.workspaceId = this.env.CO2_IMPACT_WORKSPACE_ID;
    this.reportId = this.env.CO2_IMPACT_REPORT_ID;
  }
}
